import {
  Component,
  computed,
  EventEmitter,
  inject,
  input,
  Input,
  OnChanges,
  OnInit,
  Output,
  signal,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { StandardQuoteService } from '../../standard-quote-service.service';
import {
  FinancialProductEnum,
  grace,
  payments,
  specialPayments,
} from '../../model/standard-quote.model';
import { formatDate } from '@angular/common';
import { ModalService } from '@app/components/modal/modal.service';
import { BaseComponent } from '@app/components/base/base.component';
import { Payment } from '../../model/standard-payments.model';
import { ActivatedRoute } from '@angular/router';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';

@Component({
  template: ''
})
export class PaymentsStandardQuoteWrapperComponent
  extends BaseComponent
  implements OnInit, OnChanges
{
  private readonly modalService = inject(ModalService);
  private readonly quoteService = inject(StandardQuoteService);
  @ViewChild('specialTemplate') specialTemplate!: TemplateRef<any>;

  payments = input<payments[]>([]);
  specialPayments = input<specialPayments[]>([]);
  grace = input<grace[]>([]);
  @Input() idQuote: any;
  @Input() idDeal: any;
  @Input() isEdit: boolean;
  @Input() result: any;
  @Input() tipoProductoFinanciero: FinancialProductEnum | null;

  @Output() updateSpecialPayments: EventEmitter<any> = new EventEmitter();
  @Output() updateGrace: EventEmitter<any> = new EventEmitter();

  quantity: number;
  period: any;
  isLoading: boolean = false;
  readonly filterPayments = computed(() => {
    const payments = this.payments().filter((payment) => payment?.period !== 0);
    const total = payments?.length;
    const specialPages = payments?.reduce?.(
      (acc, payment, index) => {
        const currentIndex = index + 1;
        if (this.hasPeriodGrace(payment?.period)) {
          acc.periodoGracia.push(currentIndex);
        }
        return acc;
      },
      {
        pagoEspecial: [] as number[],
        pagoIrregular: [] as number[],
        periodoGracia: [] as number[],
      }
    );
    return {
      total,
      specialPages,
      items: payments,
    };
  });
  readonly hasSpecialPayments = computed(() => this.grace()?.length > 0 || this.specialPayments()?.length > 0);
  readonly currentPage = signal(1);
  readonly openMenu = signal<boolean>(false);

  constructor(
    route: ActivatedRoute,
    menuService: MenusServices,
    notification: NotificationService,
  ) {
    super(route, menuService, notification);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['payments'] || changes['specialPayments'] || changes['grace'] || changes['quantity']) {
      if (this.payments()?.length > 0 && this.specialPayments()?.length > 0) {
        this.payments().forEach((payment: any) => {
          const correspondingSpecialPayment = this.specialPayments()?.find(
            (specialPayment) => specialPayment.period === payment.period
          );
          if (correspondingSpecialPayment) {
            payment.paymentType = 'SPECIAL_PAYMENT';
          }
        });
      }
      if (this.payments()?.length > 0 && this.grace()?.length > 0) {
        this.payments().forEach((payment: any) => {
          const correspondingSpecialPayment = this.grace().find(
            (grace) => grace.period === payment.period
          );
          if (correspondingSpecialPayment) {
            payment.paymentType = 'GRACE_PERIOD';
          }
        });
      }
    }
  }

  ngOnInit() {
    this.quantity = Number(this.quoteService.formData?.quantity);

    this.quoteService.updatedFormData.subscribe((value: any) => {
      this.quantity = Number(value.quantity);
    })
  }

  formatDate(date: any) {
    if (date) return formatDate(date, 'MMM-yyyy', 'es-Es')?.toUpperCase();
    return '';
  }

  openModal(period: any) {
    let periodSelected: any;
    let model = {};

    if (period.paymentType == 'SPECIAL_PAYMENT') {
      periodSelected = this.specialPayments().find(
        (i) => i.period == period.period
      );
    } else if (period.paymentType == 'GRACE_PERIOD') {
      periodSelected = this.grace().find((i) => i.period == period.period);
    }

    if (periodSelected) {
      model = new Payment(periodSelected, period.paymentDate);
    } else {
      model = {
        id: null,
        period: period.period,
        paymentDate: period.paymentDate,
        paymentType: null,
      };
    }

    this.period = model;
    this.period = { ...this.period, paymentType: period.paymentType };
    this.modalService.component = this.specialTemplate;
    this.modalService.openModal();
    this.openMenu.set(false);
  }

  update(payment: any) {
    if (payment.paymentType == 'SPECIAL_PAYMENT') {
      this._updateSpecialPayment(payment);
    } else if (payment.paymentType == 'GRACE_PERIOD') {
      this._updateGrace(payment);
    }
  }

  _updateGrace(grace: any) {
    let graceSelected = {
      gracePeriodDate: grace.paymentDate,
      ...grace,
    };
    let currentGrace = this.grace();
    if (graceSelected.id) {
      const index = currentGrace.findIndex((i) => i.id == grace.id);
      currentGrace[index] = graceSelected;
    } else {
      currentGrace.push(graceSelected);
    }

    this.updateGrace.emit(currentGrace);
  }

  _updateSpecialPayment(specialPayment: any){
    let specialPaymentSelected = {
      ...specialPayment,
      specialPaymentDate: specialPayment.paymentDate,
    };
    let currentSpecialPayments = this.specialPayments();
    let amount = 0;
    currentSpecialPayments.map((i) => amount += i.amount);
    amount = Number(amount) + Number(specialPayment.amount);
    if(amount > this.result.financialAmount ){
      this.showNotificationError('La suma de los montos ingresados excede el monto a financiar.');
    }else{
      if (specialPaymentSelected.id) {
        const index = currentSpecialPayments.findIndex(
          (i) => i.id == specialPaymentSelected.id
        );
        currentSpecialPayments[index] = specialPaymentSelected;
      } else {
        currentSpecialPayments.push(specialPaymentSelected);
      }
      this.updateSpecialPayments.emit(currentSpecialPayments);
    }
  }


  delete(period: any) {
    if (period.paymentType == 'SPECIAL_PAYMENT') {
      this.deleteSpecialPayment(period);
    } else if (period.paymentType == 'GRACE_PERIOD') {
      this.deleteGrace(period);
    }
  }

  deleteSpecialPayment(period: any) {
    if (!period.id) {
      this.updateSpecialPayments.emit(
        this.specialPayments().filter((i) => i.id != period.id)
      );
    }

    this.isLoading = true;
    this.quoteService
      .deleteSpecialPayments(this.idQuote, this.idDeal, period.id)
      .subscribe({
        next: (response) => {
          this.updateSpecialPayments.emit(
            this.specialPayments().filter((i) => i.id != period.id)
          );
          this.showNotificationSuccess(
            'Se ha eliminado con éxito el pago especial.'
          );
          this.isLoading = false;
        },
        error: (err) => {
          this.isLoading = false;
          this.showNotificationError(
            'Ha ocurrido un error al eliminar pago especial.'
          );
        },
      });
  }

  deleteGrace(period: any) {
    if (!period.id) {
      this.updateGrace.emit(this.grace().filter((i) => i.id != period.id));
    }
    this.isLoading = true;
    this.quoteService
      .deleteGrace(this.idQuote, this.idDeal, period.id)
      .subscribe({
        next: (response) => {
          this.updateGrace.emit(this.grace().filter((i) => i.id != period.id));
          this.showNotificationSuccess(
            'Se ha eliminado con éxito el período de gracia.'
          );
          this.isLoading = false;
        },
        error: (err) => {
          this.isLoading = false;
          this.showNotificationError(
            'Ha ocurrido un problema al eliminar período de gracia.'
          );
        },
      });
  }

  isFinancialLeasing(){
    return this.tipoProductoFinanciero == FinancialProductEnum.financialLeasing;
  }

  ngOnDestroy() {
    this.modalService.component = null;
    this.modalService.closeModal();
  }

  hasPeriodGrace(period: number) {
    if (!this.grace()) return;
    return this.grace().find((i) => i.period === period) !== undefined;
  }

  hasSpecialPayment(period: number) {
    if (!this.specialPayments()) return;
    return (
      this.specialPayments().find((i) => i.period === period) !== undefined
    );
  }

  closeMenuOptions() {
    this.openMenu.set(false);
  }

  toggleMenuOptions(e: MouseEvent) {
    e.preventDefault();
    this.openMenu.update((value) => !value);
  }

  getPaymentType(paymentType?: string) {
    if (paymentType == 'SPECIAL_PAYMENT') {
      return 'Pago especial';
    } else if (paymentType == 'GRACE_PERIOD') {
      return 'Período de gracia';
    } else if (paymentType == 'IRREGULAR_PAYMENT') {
      return 'Pago irregular';
    }
    return 'Pago regular';
  }

  onChangePage(updatePage: number) {
    this.currentPage.set(updatePage);
  }
}
